// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/TrackingService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { UuidDtoSchema, UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { TrackingDtoSchema, TrackingsOfDayDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { TrackingCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { TrackingDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { TrackingFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/TrackingService.proto.
 */
export const file_Services_TrackingService: GenFile = /*@__PURE__*/
  fileDesc("Ch5TZXJ2aWNlcy9UcmFja2luZ1NlcnZpY2UucHJvdG8yjAoKD1RyYWNraW5nU2VydmljZRLkAQoLR2V0VHJhY2tpbmcSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGjQudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5UcmFja2luZ0RldGFpbGVkRHRvIl+g2s0PAoLT5JMCVFoeOgEqIhkvYXBpL3RyYWNraW5nL2dldFRyYWNraW5nEjIvYXBpL3RyYWNraW5nL2dldFRyYWNraW5nL3tpZC5oaWdoXzY0fS97aWQubG93XzY0fRKpAQoMR2V0VHJhY2tpbmdzEjIudGltZV90cmFja2luZy5tZXNzYWdlcy5maWx0ZXJzLlRyYWNraW5nRmlsdGVyc0R0bxo5LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29sbGVjdGlvbnMuVHJhY2tpbmdDb2xsZWN0aW9uRHRvIiqg2s0PAoLT5JMCHzoBKiIaL2FwaS90cmFja2luZy9nZXRUcmFja2luZ3MSnwEKDkNyZWF0ZVRyYWNraW5nEikudGltZV90cmFja2luZy5tZXNzYWdlcy5iYXNpYy5UcmFja2luZ0R0bxo0LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuVHJhY2tpbmdEZXRhaWxlZER0byIsoNrNDwKC0+STAiE6ASoiHC9hcGkvdHJhY2tpbmcvY3JlYXRlVHJhY2tpbmcS2wEKDlVwZGF0ZVRyYWNraW5nEikudGltZV90cmFja2luZy5tZXNzYWdlcy5iYXNpYy5UcmFja2luZ0R0bxo0LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuVHJhY2tpbmdEZXRhaWxlZER0byJooNrNDwKC0+STAl06ASpaIToBKiIcL2FwaS90cmFja2luZy91cGRhdGVUcmFja2luZxo1L2FwaS90cmFja2luZy91cGRhdGVUcmFja2luZy97aWQuaGlnaF82NH0ve2lkLmxvd182NH0SzwEKDkRlbGV0ZVRyYWNraW5nEiYudGltZV90cmFja2luZy5tZXNzYWdlcy5jb21tb24uVXVpZER0bxo0LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuVHJhY2tpbmdEZXRhaWxlZER0byJfoNrNDwKC0+STAlRaIToBKiIcL2FwaS90cmFja2luZy9kZWxldGVUcmFja2luZyovL2FwaS90cmFja2luZy9kZWxldGVUcmFja2luZy97aGlnaF82NH0ve2xvd182NH0SkwIKFFVwZGF0ZVRyYWNraW5nc09mRGF5Ei8udGltZV90cmFja2luZy5tZXNzYWdlcy5iYXNpYy5UcmFja2luZ3NPZkRheUR0bxo5LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29sbGVjdGlvbnMuVHJhY2tpbmdDb2xsZWN0aW9uRHRvIo4BoNrNDwKC0+STAoIBOgEqWic6ASoiIi9hcGkvdHJhY2tpbmcvdXBkYXRlVHJhY2tpbmdzT2ZEYXkaVC9hcGkvdHJhY2tpbmcvdXBkYXRlVHJhY2tpbmdzT2ZEYXkve3VzZXJfaWQuaGlnaF82NH0ve3VzZXJfaWQubG93XzY0fS97ZGF0ZS5zZWNvbmRzfUIkqgIhTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLlNlcnZpY2VzYgZwcm90bzM", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Common, file_Messages_Basic, file_Messages_Collections, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * CRUD operations for trackings.
 *
 * @generated from service TrackingService
 */
export const TrackingService: GenService<{
  /**
   * Fetch a tracking specified by its id.
   * Policy: Users can only fetch their own trackings.
   *
   * @generated from rpc TrackingService.GetTracking
   */
  getTracking: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof TrackingDetailedDtoSchema;
  },
  /**
   * Fetch trackings according to filters.
   * Policy: Users can only fetch their own trackings.
   *
   * @generated from rpc TrackingService.GetTrackings
   */
  getTrackings: {
    methodKind: "unary";
    input: typeof TrackingFiltersDtoSchema;
    output: typeof TrackingCollectionDtoSchema;
  },
  /**
   * Create a new tracking.
   * Policy: Users and administrator can only create trackings belonging to them.
   *
   * @generated from rpc TrackingService.CreateTracking
   */
  createTracking: {
    methodKind: "unary";
    input: typeof TrackingDtoSchema;
    output: typeof TrackingDetailedDtoSchema;
  },
  /**
   * Modify tracking properties.
   * Policy: Users and administrators can only modify trackings belonging to them.
   *
   * @generated from rpc TrackingService.UpdateTracking
   */
  updateTracking: {
    methodKind: "unary";
    input: typeof TrackingDtoSchema;
    output: typeof TrackingDetailedDtoSchema;
  },
  /**
   * Delete the tracking with the given id.
   * Policy: Users and administrators can only delete trackings belonging to them.
   *
   * @generated from rpc TrackingService.DeleteTracking
   */
  deleteTracking: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof TrackingDetailedDtoSchema;
  },
  /**
   * Simultaneously manage (create, update or delete) all trackings of a single day.
   * Policy: Users and administrators can only create, modify and delete trackings belonging to them.
   *
   * @generated from rpc TrackingService.UpdateTrackingsOfDay
   */
  updateTrackingsOfDay: {
    methodKind: "unary";
    input: typeof TrackingsOfDayDtoSchema;
    output: typeof TrackingCollectionDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_TrackingService, 0);

